/**
 * Feature-link entry point for eager app code. Import from here, not from the
 * feature barrel: the barrel carries the reader page and its markdoc renderer
 * and is lazy-loaded by the authenticated layout.
 *
 * Importing this module registers the drawer slice. The slice is a few lines,
 * and registering it with the first eager import means a link can never become
 * interactive before the reducer that handles its activation exists (the lazy
 * reader module is loaded by the layout only after the gate opens).
 */
import { autoRegisterFeature } from '@store/features/factory';

import { knowledgeBaseFeature } from './store/feature';

autoRegisterFeature(knowledgeBaseFeature);

export { GUIDE_LINKS_GATE, GUIDE_SURFACES, type GuideSurfaceId } from './constants/featureLinks';
export { PAGE_GUIDES, type PageGuide, type PageGuideKey } from './constants/pageGuides';
export { GuideLink, type GuideLinkProps } from './containers/GuideLink';
export { PageGuideLink, type PageGuideLinkProps } from './containers/PageGuideLink';
export { PageViewObserver } from './containers/PageViewObserver';
export {
  type FeatureLinksAccess,
  type FeatureLinksArm,
  useFeatureLinksAccess,
} from './hooks/useFeatureLinksAccess';
export type { GuideLinkShape } from './types';
